'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _hasSubmitSucceeded = require('./selectors/hasSubmitSucceeded');

var _hasSubmitSucceeded2 = _interopRequireDefault(_hasSubmitSucceeded);

var _plain = require('./structure/plain');

var _plain2 = _interopRequireDefault(_plain);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _hasSubmitSucceeded2.default)(_plain2.default);


// WEBPACK FOOTER //
// ./~/redux-form/lib/hasSubmitSucceeded.js